<template>
	<Loader v-if="loading"></Loader>
	<template v-else>
		<Header></Header>
		<Sidebar></Sidebar>
		<div class="xpage">
			<slot></slot>
		</div>
		<modal></modal>
	<ToastNotification />
	</template>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import Loader from '../Loader.vue';
import Header from '../layout/Header.vue';
import Sidebar from '../search-page/Sidebar.vue';
import store from '@/store';
import modal from '@/components/Modal.vue';
import ToastNotification from '@/components/shared/ToastNotification.vue';

var loading = ref<boolean>(true);

onMounted(async () => {
	loading.value = false;
	store.state.mobileMenu = false;
});
</script>
